import React from 'react';
import { Button } from '../../../ui/atoms/Button';
import { SectionHeader } from '../../../ui/molecules/SectionHeader';
import type { Contact } from '../resume.types';

type ContactSectionProps = {
  contact: Contact;
  contactAddress?: string;
  resumePdfUrl: string;
};

export function ContactSection({
  contact,
  contactAddress,
  resumePdfUrl,
}: ContactSectionProps) {
  return (
    <section
      id="contact"
      className="px-4 py-16 bg-stone-100/50 dark:bg-stone-800/50"
      aria-labelledby="contact-heading"
    >
      <div className="mx-auto max-w-4xl">
        <SectionHeader
          id="contact-heading"
          title="Contact"
          subtitle="Get in touch"
        />
        <div className="grid gap-8 md:grid-cols-2">
          <div>
            <h3 className="font-display text-lg font-semibold text-stone-800 dark:text-stone-100">
              Contact Address
            </h3>
            <p className="mt-2 text-stone-600 dark:text-stone-400">
              {contactAddress ?? contact.location}
            </p>
            <ul className="mt-4 space-y-2 text-stone-600 dark:text-stone-400">
              <li>
                <a
                  href={`mailto:${contact.email}`}
                  className="hover:text-emerald-600 hover:underline dark:hover:text-emerald-400"
                >
                  {contact.email}
                </a>
              </li>
              <li>
                <a
                  href={`tel:${contact.phone.replace(/\s/g, '')}`}
                  className="hover:text-emerald-600 hover:underline dark:hover:text-emerald-400"
                >
                  {contact.phone}
                </a>
              </li>
            </ul>
            <div className="mt-6 flex flex-wrap gap-3">
              <Button href={resumePdfUrl} aria-label="Download resume PDF">
                Download Resume
              </Button>
              <Button
                href={`mailto:${contact.email}`}
                variant="outline"
                aria-label="Contact by email"
              >
                Contact Me
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
